import { BIN_VALIDATION_RESULTS } from '../../api/vip-api-constants';

const binValidationParser = error => {
    let validationTitle;
    let validationBody;
    switch (error) {
        case BIN_VALIDATION_RESULTS.ITEM_NOT_FOUND:
            validationTitle = 'vip_bid_itemNotFoundTitle';
            validationBody = 'vip_bid_itemNotFoundBody';
            break;
        case BIN_VALIDATION_RESULTS.BIDDER_IS_BLOCKED:
            validationTitle = 'vip_bid_bidderIsBlockedTitle';
            validationBody = 'vip_bid_bidderIsBlockedBody';
            break;
        case BIN_VALIDATION_RESULTS.BUYING_OWN_ITEM:
            validationTitle = 'vip_bid_biddingOrBuyingOwnItemTitle';
            validationBody = 'vip_bid_biddingOrBuyingOwnItemBody';
            break;
        case BIN_VALIDATION_RESULTS.ONLY_EU_BUYERS_ACCEPTED:
            validationTitle = 'vip_bid_onlyEUBuyersAcceptedTitle';
            validationBody = 'vip_bid_onlyEUBuyersAcceptedBody';
            break;
        case BIN_VALIDATION_RESULTS.ONLY_NORDIC_BUYERS_ACCEPTED:
            validationTitle = 'vip_bid_onlyNordicBuyersAcceptedTitle';
            validationBody = 'vip_bid_onlyNordicBuyersAcceptedBody';
            break;
        case BIN_VALIDATION_RESULTS.ONLY_SWEDISH_BUYERS_ACCEPTED:
            validationTitle = 'vip_bid_onlySwedishBuyersAcceptedTitle';
            validationBody = 'vip_bid_onlySwedishBuyersAcceptedBody';
            break;
        case BIN_VALIDATION_RESULTS.USER_IS_SUSPENDED:
            validationTitle = 'vip_bid_userIsSuspendedTitle';
            validationBody = 'vip_bid_userIsSuspendedBody';
            break;
        case BIN_VALIDATION_RESULTS.ITEM_HAS_ENDED:
            validationTitle = 'vip_bid_auctionHasEndedTitle';
            validationBody = 'vip_bid_auctionHasEndedBody';
            break;
        case BIN_VALIDATION_RESULTS.PURCHASE_DID_NOT_SUCCEED:
        case BIN_VALIDATION_RESULTS.ITEM_ALREADY_PURCHASED_BY_OTHER_USER:
        default:
            validationTitle = 'vip_bid_errorTitle';
            validationBody = 'vip_bid_errorDescription';
            break;
    }

    return {
        validationTitle,
        validationBody
    };
};

export default binValidationParser;
